import { PUBLIC_EVENTS, PRIVATE_EVENTS, EVENT_CALLBACK } from '../handlers/EventManager/constants';
import { JSON_DATA_BASE_URL } from '../constants/FixtureConstants';

class JSONManager {
  constructor(sportsManager, JSONConfig) {
    this.JSONConfig = JSONConfig;
    this.eventManager = sportsManager.eventManager;
    this.subscribeToEvents();
    this.init();
  }

  init() {
    this.eventManager.broadcastPublicEvent(PRIVATE_EVENTS.FIXTURES_DATA_UPDATE, { success: true });
  }

  fetchJSONData(sportsId, tournamentId, status, pageNum, jsonConfig, isJson=false) {
    if(isJson) {
      return new Promise((resolve, reject) => {
        fetch(
          `${JSON_DATA_BASE_URL}/${sportsId}/${tournamentId}/${status}/page_${pageNum}.json`,
          { mode: 'cors' }
        ).then((jsonResponse) => {
          jsonResponse.json().then((jsonData) => {
            resolve(jsonData);
          });
        });
      });
    } else {
      let baseUrl = jsonConfig?.api_endpoint ? jsonConfig?.api_endpoint : JSON_DATA_BASE_URL
      return new Promise((resolve, reject) => {
        fetch(
          `${baseUrl}/v1/get/tour?sid=${sportsId}&tid=${tournamentId}&event=${status}&page=${pageNum}`,
          { method: 'GET',
            headers: {
              'Authorization': `Bearer ${jsonConfig?.authorization}`,
              'security_token': jsonConfig?.security_token,
            },
          }
        ).then((jsonResponse) => {
          jsonResponse.json().then((jsonData) => {
            resolve(jsonData);
          })
          .catch(() => {
            resolve({});
          });
        });
      });
    }
  }

  subscribeToEvents() {
    this.eventManager.subscribeToEvents({
      eventType: EVENT_CALLBACK.PRIVATE_EVENTS,
      eventCallback: this.privateEventCallback.bind(this),
      senderName: 'JSON_MANAGER',
    });

    this.eventManager.subscribeToEvents({
      eventType: EVENT_CALLBACK.PUBLIC_EVENTS,
      eventCallback: this.publicEventCallback.bind(this),
      senderName: 'JSON_MANAGER',
    });
  }

  privateEventCallback(eventName, eventData) {
    switch (eventName) {
      case PRIVATE_EVENTS.TEST_START_PRIVATE: {
        console.log(eventName, eventData);
      }
    }
  }

  publicEventCallback(eventName, eventData) {
    switch (eventName) {
      case PUBLIC_EVENTS.TEST_START_PUBLIC: {
        console.log(eventName, eventData);
      }
    }
  }

  broadcastPublicEvent(eventName, eventData) {
    this.eventManager.broadcastPublicEvent(eventName, eventData);
  }
}

export default JSONManager;
